var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _c(
        "b-navbar",
        {
          staticStyle: {
            "justify-content": "center",
            background: "#0050b3 !important",
            "box-shadow": "0px 4px 4px rgb(0 0 0 / 20%)",
            padding: "0px 10px",
          },
          attrs: { toggleable: "lg", type: "dark", variant: "info" },
        },
        [
          _c(
            "b-navbar-brand",
            { staticStyle: { "font-size": "40px" }, attrs: { href: "#" } },
            [_vm._v("CỤC VIỄN THÔNG")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "formLogin",
          staticClass: "demo-formLogin",
          attrs: {
            autocomplete: "off",
            align: "center",
            model: _vm.formLogin,
            "status-icon": "",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm($event)
            },
          },
        },
        [
          _c("span", { staticClass: "title_login" }, [
            _vm._v("Chào mừng đến với"),
          ]),
          _vm._v(" "),
          _c("el-divider", { staticClass: "line-login" }),
          _vm._v(" "),
          _c("img", {
            staticClass: "image",
            attrs: { src: require("../../../content/icon/login_vnta.svg") },
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "username" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    type: "text",
                    autocomplete: "on",
                    placeholder: "Tên đăng nhập",
                  },
                  model: {
                    value: _vm.formLogin.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.formLogin, "username", $$v)
                    },
                    expression: "formLogin.username",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { slot: "prefix", icon: "user" },
                    slot: "prefix",
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { slot: "suffix", icon: "times-circle" },
                    on: {
                      click: function ($event) {
                        return _vm.resertInput("username")
                      },
                    },
                    slot: "suffix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "password" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    type: "password",
                    autocomplete: "on",
                    placeholder: "Mật khẩu",
                  },
                  model: {
                    value: _vm.formLogin.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.formLogin, "password", $$v)
                    },
                    expression: "formLogin.password",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { slot: "prefix", icon: "lock" },
                    slot: "prefix",
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { slot: "suffix", icon: "times-circle" },
                    on: {
                      click: function ($event) {
                        return _vm.resertInput("password")
                      },
                    },
                    slot: "suffix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "btn_login",
                  attrs: { type: "primary", "native-type": "submit" },
                },
                [_vm._v("Đăng nhập")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }